import React from 'react';
import TableYearsNavArrowsLeft from './TableYearsNavArrowsLeft';
import { useScorecardContext } from '@/creditflowresearch/application/League/Scorecard/ScorecardContext';

const TableYearsNavArrowsLeftContainer = () => {
  const { state: { columnState }, decreaseVolumeTablePosition } = useScorecardContext();
  const { valueTableIndex } = columnState;
  const isDisabled = valueTableIndex === 0;

  return (
    <TableYearsNavArrowsLeft
      isDisabled={ isDisabled }
      decreaseTablePosition={ decreaseVolumeTablePosition }
    />
  );
};

export default TableYearsNavArrowsLeftContainer;
